import React from 'react';
import { Wrapper } from '../../../components/Wrapper';
import { InterfaceWrapper } from '../../../components/InterfaceWrapper';
import { PlayerInterface } from './PlayerInterface';
import { Content } from './Content';

export const FishStockingLevel = InterfaceWrapper({
  Interface: PlayerInterface,
  Step: ({ data, fetching }) => {
    return (
      <Wrapper>
        <Content data={data} fetching={fetching} />
      </Wrapper>
    );
  },
});
